var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRatingStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2503_6444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9583 5.8254C15.9071 5.66684 15.8104 5.52685 15.6802 5.42288C15.5501 5.31891 15.3922 5.25555 15.2262 5.24069L10.6082 4.82134L8.78209 0.547169C8.6474 0.233943 8.34077 0.03125 8.00007 0.03125C7.65937 0.03125 7.35271 0.233974 7.21808 0.547951L5.39197 4.82137L0.7732 5.24069C0.607451 5.25588 0.449802 5.31937 0.3198 5.42331C0.189799 5.52725 0.0931609 5.66705 0.0418688 5.8254C-0.0634776 6.14941 0.0338061 6.50476 0.290531 6.72876L3.78125 9.79009L2.75191 14.3243C2.67659 14.6577 2.80597 15.0023 3.0826 15.2022C3.23126 15.3097 3.40524 15.3644 3.58065 15.3644C3.7319 15.3644 3.8819 15.3236 4.01659 15.243L8.00007 12.8622L11.9821 15.243C12.2735 15.4183 12.6408 15.4023 12.9168 15.2022C13.0519 15.1044 13.1553 14.9691 13.2141 14.813C13.2729 14.6569 13.2845 14.4869 13.2475 14.3243L12.2182 9.79009L15.7089 6.72939C15.8345 6.61972 15.925 6.47557 15.9694 6.31485C16.0137 6.15414 16.0099 5.98394 15.9583 5.8254Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2503_6444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar);
export default __webpack_public_path__ + "static/media/RatingStar.00f6710196c4cc4cd8cba44e1a583088.svg";
export { ForwardRef as ReactComponent };